const PSISettingsRoutes: any = {
    path: 'psi',
    name: 'psi-settings',
    component: () => import('@/views/Project/PSI/views/Settings/Index.vue'),
    meta: {
        permission: ['psi.admin'],
        requireProject: true,
        title: 'project_menu.settings',
    },
    redirect: { name: 'psi-all-settings' },
    children: [
        {
            path: 'qr',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'psi-qr-settings',
            component: () => import('@/views/Project/PSI/views/Settings/qr.vue'),
        },
        {
            path: 'forms',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'psi-all-settings',
            component: () => import('@/views/Project/PSI/views/Settings/PSIs.vue'),
        },
    ],
}

export default PSISettingsRoutes
